/* global SmartOrderRefillSettings */
/**
 *  Property of OSF GLOBAL SERVICES INC. , an OSF Digital company. OSF remains the sole owner of all right, title and interest in the software. Do not copy, sell, reverse engineer or otherwise attempt to derive or obtain information about the functioning, manufacture or operation therein.
 */

const sorHelpers = require('../sorHelpers/sorHelpers');

const reactivateSubscriptionSave = function (e) {
  if (!e.detail || e.detail === 1) {
    const $form = $('#reactiveSubs');
    const $loaderHost = sorHelpers.sorLoader.getModalHost($form);
    sorHelpers.sorLoader.start($loaderHost);
    $.ajax({
      type: 'POST',
      url: $form.attr('action'),
      data: $form.serialize(),
      success: function (response) {
        if (response.success) {
          if (response.toastMessage) {
            sessionStorage.setItem('sorToastMessage', response.toastMessage);
          }
          sorHelpers.sorModal.closeModal();
          window.location.href = SmartOrderRefillSettings.Urls.manageOrders;
        } else {
          sorHelpers.sorLoader.stop($loaderHost);
          sorHelpers.sorModal.initErrorModal(SmartOrderRefillSettings.Resources.SOR_UNEXPECTED_ERROR, false);
        }
      },
      error: function (err) {
        if (err.responseJSON && err.responseJSON.redirectURL) {
          window.location.href = err.responseJSON.redirectURL;
        } else {
          sorHelpers.sorLoader.stop($loaderHost);
          sorHelpers.sorModal.initErrorModal(SmartOrderRefillSettings.Resources.SOR_UNEXPECTED_ERROR, false);
        }
      }
    });
  }
};

const reactivateSubscriptionOptions = {
  autoOpen: true,
  bgiframe: true,
  title: typeof SmartOrderRefillSettings !== 'undefined' ? SmartOrderRefillSettings.Resources.SOR_REACTIVE_SUBSCRIPTION_TITLE : '',
  modal: true,
  emptyOnClose: false,
  width: '25rem',
  buttons: {
    SOR_GLOBAL_CLOSE: sorHelpers.sorModal.closeModal,
    SOR_GLOBAL_RESUBSCRIBE: reactivateSubscriptionSave
  }
};

const initReactivateSubscription = function () {
  $(document)
    .off('click', '.reactivatesubscription')
    .on('click', '.reactivatesubscription', function (e) {
      if (!e.detail || e.detail === 1) {
        e.preventDefault();
        const $trigger = $(this);
        if ($trigger.children('.veil').length) {
          return;
        }
        $trigger.spinner().start();
        const url = $trigger.attr('data-link');
        const $container = sorHelpers.sorModal.createContainer('#reactivate-subscription');

        $container.load(url, function () {
          const showReactivateModal = $container.find('input[name=productAvailability]').val() === 'true';
          if (showReactivateModal) {
            sorHelpers.sorModal.createModal($container, reactivateSubscriptionOptions);
            sorHelpers.sorModal.onShown($container, function () {
              $trigger.spinner().stop();
            });
          } else {
            $trigger.spinner().stop();
            sorHelpers.sorModal.initWarningModal(SmartOrderRefillSettings.Resources.SOR_REACTIVATE_PRODUCT_AVAILABILITY_WARNING);
          }
        });
      }
    });
};

module.exports = {
  initReactivateSubscription: initReactivateSubscription
};
